import { Box } from "@mui/material";
import SectionCollapsible from "../../../common/SectionCollapsible";
import { buildIntegrityScoreFields } from "../fields/integrityScores";
import SectionFields from "../tabs/common/Section/SectionFields";
import type { ReadOnlyPillarsContainerProps } from "../tabs/types";

function ReadOnlyIntegrityScoresContainer({
  pillars,
}: ReadOnlyPillarsContainerProps) {
  return (
    <Box data-testid="read-only-integrity-scores-container">
      <SectionCollapsible label="Integrity Scores">
        <SectionFields
          fields={buildIntegrityScoreFields(pillars)}
          columns={2}
          fieldIdPrefix="read-only-integrity-scores"
          highlightMissingFields={false}
        />
      </SectionCollapsible>
    </Box>
  );
}

export default ReadOnlyIntegrityScoresContainer;
